import { JSX } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import ModuleVersionTableEmptyCell from "views/Account/Module/Version/components/TableEmptyCell";
import ModuleVersionTableNameCell from "views/Account/Module/Version/components/TableNameCell";

import {
  MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID,
  MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID,
} from "../constants";
import { ModuleVersionModuleDependencyRow, ModuleVersionProviderDependencyRow } from "../types";
import ModuleVersionDependenciesTableSourceCell from "./SourceCell";
import ModuleVersionDependenciesTableVersionCell from "./VersionCell";

export const MODULE_VERSION_MODULE_DEPENDENCIES_TABLE_CELLS: Record<
  MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionModuleDependencyRow>) => JSX.Element
> = {
  [MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID.NAME]: ModuleVersionTableNameCell,
};

export const MODULE_VERSION_PROVIDER_DEPENDENCIES_TABLE_CELLS: Record<
  MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionProviderDependencyRow>) => JSX.Element
> = {
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.NAME]: ModuleVersionTableNameCell,
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.VERSION]:
    ModuleVersionDependenciesTableVersionCell,
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.SOURCE]: ModuleVersionDependenciesTableSourceCell,
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.DROPDOWN]: ModuleVersionTableEmptyCell,
};
